import { Text } from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import {
	CanalDeContacto,
	CarlineSelect,
	ConsentQuestion,
	Loading,
	NombreApellidos,
	TelefonoEmail,
} from 'src/components';
import { useIsComerciales } from 'src/feature-app';
import { LayoutWrapper } from 'src/feature-app/Screen';
import { ConfirmacionLeadsNoQuestions } from 'src/forms';
import { LegalDatosPersonalesLeads, MapaLeads } from 'src/forms/Leads';
import { MapaLeadsInPage } from 'src/forms/Leads/InPage';
import { FormInfo, Steps } from 'src/types';
import { partialDataLeadsCitaVenta } from '.';
import { LeadGenericoController } from '../LeadGenericoController';
import { LeadsFormsProps } from '../LeadGenericoForm';
import { useInitializeLeadForm } from '../use-initialize-lead-form';

const getMapaFields = (inPage: boolean) => {
	if (inPage === true) {
		return <MapaLeadsInPage formName="venta" showHorario={true} />;
	} else {
		return <MapaLeads formName="venta" showHorario={true} />;
	}
};

enum CitaVentaSteps {
	Mapa,
	Modelo,
	NombreApellido,
	Contacto,
	EmailTelefono,
	Lssi,
	Tmk,
	Confirmacion,
}

export function CitaVentaForm({
	inPage,
	isConfigurador,
	isLeadDealer,
}: LeadsFormsProps) {
	const [partialData, setPartialData] = useState(null);
	const isComerciales = useIsComerciales();

	useEffect(() => {
		setPartialData(partialDataLeadsCitaVenta(isConfigurador, isLeadDealer));
	}, []);

	const defaultSteps: Steps[] = [
		isLeadDealer
			? null
			: {
					screenIndex: CitaVentaSteps.Mapa,
					name: 'Mapa',
					multiStep: true,
					component: getMapaFields(inPage),
			  },
		{
			title: (
				<>
					<Text bold>¿{isLeadDealer ? 'Qué ' : 'Y qué '}modelo </Text>{' '}
					te interesa?
				</>
			),
			fields: (
				<LayoutWrapper>
					<CarlineSelect useCarline={true} />
				</LayoutWrapper>
			),
			screenIndex: CitaVentaSteps.Modelo,
			name: 'Modelo',
			outputs: ['modelo'],
			outputsText: ['modelo'],
		},
		{
			title: (
				<>
					Para poder preparar tu visita, necesitamos saber{' '}
					<Text bold>quién eres</Text>
				</>
			),
			fields: (
				<LayoutWrapper>
					<NombreApellidos />
				</LayoutWrapper>
			),
			screenIndex: CitaVentaSteps.NombreApellido,
			name: 'NombreApellido',
			outputs: ['name', 'surname', 'secondSurname'],
			outputsText: ['name', 'surname', 'secondSurname'],
		},
		{
			title: (
				<>
					<Text bold>¿Cómo prefieres </Text>que contactemos contigo?
					<sup style={{ top: 'auto', fontSize: '100%' }}>*</sup>
				</>
			),
			fields: (
				<LayoutWrapper>
					<CanalDeContacto />
				</LayoutWrapper>
			),
			screenIndex: CitaVentaSteps.Contacto,
			name: 'Contacto',
			outputs: ['contacto'],
			outputsText: ['contacto'],
		},
		{
			title: (
				<>
					Para ello necesitaremos{' '}
					<Text bold>tus datos de contacto</Text>
					<LegalDatosPersonalesLeads />
				</>
			),
			fields: (
				<LayoutWrapper>
					<TelefonoEmail
						hidePrefijo={isComerciales}
						requiredEmail
						requiredTelefono
					/>
				</LayoutWrapper>
			),
			screenIndex: CitaVentaSteps.EmailTelefono,
			name: 'EmailTelefono',
			outputs: ['cellphone', 'email'],
			outputsText: ['cellphone', '/', 'email'],
		},
		{
			fields: <ConsentQuestion questionType="lssi" />,
			screenIndex: CitaVentaSteps.Lssi,
			name: 'lssi',
			outputs: ['lssi'],
		},
		{
			fields: <ConsentQuestion questionType="tmk" />,
			screenIndex: CitaVentaSteps.Tmk,
			name: 'tmk',
			outputs: ['tmk'],
		},
		{
			fields: <ConfirmacionLeadsNoQuestions />,
			screenIndex: CitaVentaSteps.Confirmacion,
			isLastStep: true,
			hidePreviousStep: true,
			name: 'Confirmacion',
		},
	];
	const filteredSteps = defaultSteps.filter(step => step !== null);
	const { loading, steps, firstStep, lastStep } = useInitializeLeadForm(
		filteredSteps,
		false,
		inPage,
	);

	const citaVentaInfo: Partial<FormInfo> = {
		numberOfScreens: steps.length,
	};

	return loading ? (
		<Loading />
	) : (
		<LeadGenericoController
			steps={steps}
			leadData={partialData}
			leadInfo={citaVentaInfo}
			firstStep={firstStep}
			lastStep={lastStep}
			inPage={inPage}
			isConfigurador={isConfigurador}
		/>
	);
}
